import request from '@/utils/request'

//添加一天的排课模板
export function addnew(data) {
  return request({
    url: '/admin/schedule/addnew',
    method: 'post',
    data: data
  })
}
//查询所有的模板名
export function selectList(params) {
  return request({
    url: '/admin/schedule/selectList',
    method: 'get',
    params: params
  })
}
//校验
export function verify(data) {
  return request({
    url: '/admin/releaselesson/verify',
    method: 'post',
    data: data
  })
}
//删除
export function delTemplate(params) {
  return request({
    url: '/admin/releaselesson/delTemplate',
    method: 'get',
    params: params
  })
}
//拷贝模板信息
export function copyTemplate(params) {
  return request({
    url: '/admin/schedule/copyTemplate',
    method: 'get',
    params: params
  })
}

//查询一天的排课模板
export function selectSchedule(params) {
  return request({
    url: '/admin/schedule/selectSchedule',
    method: 'get',
    params: params
  })
}
//更新一天的排课模板
export function updateSchedule(data) {
  return request({
    url: '/admin/schedule/updateSchedule',
    method: 'post',
    data: data
  })
}
//查询当前门店课程
export function qlLevelLesson(params) {
  return request({
    url: '/admin/level/lesson/qlLevelLesson',
    method: 'GET',
    params: params
  })
}
//查询当前门店教室
export function selectAllGET(params) {
  return request({
    url: '/admin/classroom/selectAll',
    method: 'GET',
    params: params
  })
}

export function qlScheduleBs(params) {
  return request({
    url: '/admin/schedule/qlScheduleBs',
    method: 'get',
    params: params
  })
}

export function saveScheduleBs(data) {
  return request({
    url: '/admin/schedule/saveScheduleBs',
    method: 'post',
    data: data
  })
}
//临时加课
export function temporaryReleaseLesson(data) {
  return request({
    url: '/admin/releaselesson/temporaryReleaseLesson',
    method: 'post',
    data: data
  })
}

//查询课程详情
export function storeReleaseDetail(params) {
  return request({
    url: '/admin/releaselesson/storeReleaseDetail',
    method: 'get',
    params: params
  })
}
//修改课程
export function updateReleaseLessonInfo(data) {
  return request({
    url: '/admin/releaselesson/updateReleaseLessonInfo',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/scheduleTimeTemplate.js